import { render, staticRenderFns } from "./verticalTable.vue?vue&type=template&id=109c9696&scoped=true&"
import script from "./verticalTable.vue.js?vue&type=script&lang=js&"
export * from "./verticalTable.vue.js?vue&type=script&lang=js&"
import style0 from "./verticalTable.vue?vue&type=style&index=0&id=109c9696&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109c9696",
  null
  
)

export default component.exports